import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-paciente-monitorado',
  templateUrl: './paciente-monitorado.component.html',
  styleUrls: ['./paciente-monitorado.component.scss']
})
export class PacienteMonitoradoComponent {

  @Input() pacienteAtual: any;
  @Input() pacienteInicial: any;
  @Input() temDependentes = false;

  @Output() selecionarDependente = new EventEmitter<void>();
  @Output() voltarPaciente = new EventEmitter<void>();
}
